<template>
  <form class="search-container" @submit.prevent="onSearch">
    <label for="search" class="search-label">
      <div class="search-input-wrapper">
        <input
          v-model="query"
          id="search"
          type="text"
          class="search-input"
          placeholder="Search"
        />
        <span
          class="search-icon"
          @keypress.enter.prevent="onSearch"
          @click="onSearch"
        >
          <img src="@/assets/search-icon.svg" alt="Search Icon" />
        </span>
      </div>
    </label>
  </form>
</template>

<script lang="ts" setup>
import { ref, watch, defineEmits, defineProps } from 'vue';
import debounce from 'lodash.debounce';

const props = defineProps<{ initialQuery: string }>();
const emits = defineEmits(['update:query', 'search']);

const query = ref(props.initialQuery);

watch(
  () => props.initialQuery,
  (newQuery) => {
    query.value = newQuery;
  },
  { immediate: true },
);

const onSearch = () => {
  emits('update:query', query.value);
  emits('search', query.value);
};

const debouncedSearch = debounce(() => {
  emits('update:query', query.value);
  emits('search', query.value);
}, 300);

watch(query, debouncedSearch);
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.search-container {
  margin: 20px 0;

  @media (max-width: 768px) {
    width: 80%;
  }

  @media (max-width: 480px) {
    width: 90%;
  }
}

.search-label {
  font-size: 1em;
  margin-bottom: 5px;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  width: 64vw;

  .search-input {
    font-family: 'Montserrat';
    width: 100%;
    padding: 15px 55px;
    font-size: 1em;
    margin-bottom: 10px;
    border-radius: 16px;
    background: rgba(202, 194, 164, 0.1);
    border: 1px solid $color-input-border;
    outline: none;
    color: $color-foreground;

    &::placeholder {
      font-weight: 500;
      font-size: 0.8em;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      color: $color-foreground;
    }
  }

  .search-icon {
    position: absolute;
    top: 42%;
    left: 22px;
    transform: translateY(-50%);
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
